import { useEffect } from 'react'
import {
  broadcastToParent,
  RegisteredEventName
} from '@finanzcheck/catalyst-pollard'
import { getCookie, COOKIE_KEY_FCID } from 'utils/cookie'
import { getOptimizelyTrackingAttribute } from 'utils/tracking'
import { getAgeGroupFromAge } from 'utils/userState'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import useUserState from 'hooks/useUserState'

export const usePremiumAndAgeGroupTracking = () => {
  const {
    rootStore: {
      traversal: { data }
    }
  } = useRootStore()

  const { debtorsAge, isPremium } = useUserState()

  useEffect(() => {
    broadcastToParent({
      eventName: RegisteredEventName.tracking,
      data: {
        event: 'is_premium_customer',
        context: {
          Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
          ...getOptimizelyTrackingAttribute(data)
        },
        payload: {
          is_premium_customer: isPremium
        }
      }
    })
    broadcastToParent({
      eventName: RegisteredEventName.tracking,
      data: {
        event: 'age_group',
        context: {
          Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
          ...getOptimizelyTrackingAttribute(data)
        },
        payload: {
          value: getAgeGroupFromAge(debtorsAge)
        }
      }
    })
  }, [isPremium, debtorsAge, data.system.advertisementId])

  return { isPremium, debtorsAge }
}
